import { __assign } from "tslib";
import React from 'react';
import UnknownMonoHtmlView from './UnknownHtml';
import UnknownMonoReactView from './Unknown';
var UnknownMonoView = function (props) {
    if (props.isHtml) {
        return React.createElement(UnknownMonoHtmlView, __assign({}, props));
    }
    return React.createElement(UnknownMonoReactView, __assign({}, props));
};
UnknownMonoView.displayName = 'UnknownMonoView';
export default UnknownMonoView;
//# sourceMappingURL=index.js.map